export const APL_LOGO = "/affiliates/antigua-premier-league.webp";

export const competitionLogo = (comp) =>
  comp?.logo_url || (/premier/i.test(comp?.name || "") ? APL_LOGO : null);
